/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'Navigation/Menu': {
    width: 32,
    height: 32,
    viewBox: '0 0 32 32',
    data: '<path pid="0" fill-rule="evenodd" d="M25.75 8H7a.25.25 0 0 0-.223.138l-.75 1.5A.25.25 0 0 0 6.25 10h19.5a.25.25 0 0 0 .25-.25v-1.5a.25.25 0 0 0-.25-.25m0 7H7a.25.25 0 0 0-.223.138l-.75 1.5A.25.25 0 0 0 6.25 17h19.5a.25.25 0 0 0 .25-.25v-1.5a.25.25 0 0 0-.25-.25m0 7H7a.25.25 0 0 0-.223.138l-.75 1.5A.25.25 0 0 0 6.25 24h19.5a.25.25 0 0 0 .25-.25v-1.5a.25.25 0 0 0-.25-.25"/>'
  }
})
